import React from "react";
import { Link } from "react-router-dom";


const AboutComponent = ({index, content}) => {
  return (
    <section className="banner-area" style={{marginTop: "2rem", marginBottom: "3rem"}}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="banner-img wow fadeInLeft" data-wow-delay=".4s">
              <img src={content.img} alt="" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="banner-content">
              <h1
                className="title wow fadeInUp"
                data-wow-delay=".4s"
                style={{ marginBottom: "12px", fontSize: "2.6rem" }}
              >
                {content.h2}</h1>
              <p style={{ marginBottom: "25px" }}>
                {content.para}
              </p>
            
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutComponent;
